import { UserSettings } from 'types';

export const defaultSettings: UserSettings = {
  massPriceJobTableConfig: [
    'surveyJobTitle',
    'comments',
  ],
  companyJobMapping: [
    'companyJobTitle',
    'companyJobFamily',
    'companyJobLevel',
    'surveyJobFamily',
    'surveyJobLevel',
  ],
  companyJobMappingRecommendations: [
    'companyJobTitle',
    'companyJobFamily',
    'companyJobSubFamily',
    'companyJobLevel',
    'surveyJobFamily',
    'surveyJobSubFamily',
    'surveyJobFocus',
    'careerLevel',
    'recommendedSurveyJobFamily',
    'recommendedSurveyJobSubFamily',
    'recommendedSurveyJobFocus',
    'recommendedCareerLevel',
  ],
  companyLevelMapping: [
    'companyJobLevelCode',
    'companyJobCategoryCode',
  ],
  companyJobTableConfig: [
    'companyJobTitle',
    'companyJobFamily',
    'companyJobLevel',
    'surveyJobFamily'
  ],
  addSurveyDataTableConfig: [
    'surveyJobTitle',
    'surveyJobCode',
    'surveyVendorName',
    'surveyJobProfileName',
    'surveyJobGlobalGradeCode',
    'surveyJobGlobalGradeTitle',
    'surveyJobCareerLevelCode',
    'surveyJobCareerLevelTitle',
    'surveyName',
    'effectiveDate',
    'base25th',
    'base50th',
    'base75th',
    'baseOrgs',
    'baseIncs',
    'actualTotalCash25th',
    'actualTotalCash50th',
    'actualTotalCash75th',
    'actualTotalCashOrgs',
    'actualTotalCashIncs'
  ],
  priceJobTableConfig: [
    'companyJobTitle',
    'companyJobLevel',
    'planName',
    'planEffectiveDate',
    'paymarketName',
    'numCompanyEmployees',
    'base25th',
    'base50th',
    'base75th',
    'totalCash25th',
    'totalCash50th',
    'totalCash75th',
    'avgCompanyTotalCash',
    'tags',
    'comments',
  ],
  modelSalaryRangeDetailsTableConfig: [
    'rangeName',
    'rangeZone',
    'rangeGroup',
    'currency',
    'typeOfPay',
    'min',
    'mid',
    'max',
    'spread',
    'midpointDiff',
    'midpointChange',
    'positionInRange',
    'compaRatio',
    'guidelinesProgressionTarget',
    'guidelinesSpreadTarget',
    'currentMin',
    'currentMid',
    'currentMax',
    'currentSpread',
    'currentMidpointDiff',
    'midChangePercent',
    'midChange',
    'currentPositionInRange',
    'currentCompaRatio',
    'avgYoY',
    'jobWeighted',
    'employeeWeighted',
    'avgToMarket',
    'numJobs',
    'eesNumEmployees',
    'belowMin',
    'noData',
    'q1',
    'q2',
    'q3',
    'q4',
    'aboveMax',
    'totalSum',
    'belowMinSum',
  ],
  companyLevelConfig: [
    'loadedName',
    'sort',
    'levelCode',
    'levelTitle',
    'levelDescription',
    'categoryTitle',
  ],
  rangesTableConfig: [
    'rangeZoneLevel1',
    'rangeZoneLevel2',
    'rangeZoneLevel3',
    'rangeZone',
    'rangeGroupLevel1',
    'rangeGroupLevel2',
    'rangeGroupLevel3',
    'rangeGroup',
    'name',
    'min',
    'mid',
    'max',
    'spread',
    'midpointDiff',
    'currency',
    'typeOfPay',
  ],
  companyJobRewriteTableConfig: [
    'companyJobCode',
    'rangeName'
  ],
  modelCompositesTableConfig: [
    'jobLevel',
    'jobFamily',
    'jobSubFamily',
    'paymarket',
    'currentRangeName',
    'rangeName',
    'rangeZone',
    'rangeGroup',
    'currency',
    'recommendedRangeName',
    'recommendedMid',
    'min',
    'mid',
    'max',
    'spread',
    'midpointDiff',
    'midpointChange',
    'positionInModeledRange',
    'modeledCompaRatio',
    'currentMin',
    'currentMid',
    'currentMax',
    'currentSpread',
    'currentMidpointDiff',
    'midChangePercent',
    'midChange',
    'currentPositionInRange',
    'currentCompaRatio',
    'avgYoY',
    'jobWeighted',
    'employeeWeighted',
    'avgToMarket',
    'numJobs',
    'numEmployees',
    'noData',
    'belowMin',
    'q1',
    'q2',
    'q3',
    'q4',
    'aboveMax',
    'totalSum',
    'belowMinSum',
    'companyJobTitle',
    'base25th',
    'base50th',
    'base75th',
    'targetTotalCash25th',
    'targetTotalCash50th',
    'targetTotalCash75th',
  ],
  compositePercentilesTableConfig: [
    'companyJobCode',
    'paymarketName',
    'companyJobFamily',
    'companyJobLevelTitle',
    'companyJobLevelCode'
  ],
  modelRangeSetTableConfig: [
    'name',
    'lastEditedByUser',
    'status',
    'rSquared',
    'totalBelowMin',
    'totalBelowMinSum',
  ],
  employeesTableConfig: [
    'employeeId',
    'firstName',
    'lastName',
    'jobTitle',
    'baseSalary',
    'hireDate',
  ],
  massPriceJobRecordsPerPage: 10,
  rangeAssignmentsTableConfig: [],
};
